import { GridColumn } from 'src/components/GridWrapper';

export const InvoiceColumns: GridColumn<any>[] = [
  {
    field: 'invoiceNumber',
    title: 'Invoice #',
    filter: 'text',
    width: '150px',
    format: '',
    dataType: 'string',
  },
  {
    field: 'docType',
    title: 'Doc Type',
    filter: 'text',
    width: '150px',
    format: '',
    dataType: 'string',
  },
  {
    field: 'documentQty',
    title: 'Invoice Quantity',
    filter: 'numeric',
    format: '',
    width: '150px',
    dataType: 'number',
    filterFormat: '#',
    step: 1,
  },
  {
    field: 'invoiceTotal',
    title: 'Invoice Total',
    filter: 'numeric',
    format: '',
    width: '150px',
    dataType: 'number',
    filterFormat: 'c',
  },
  {
    field: 'statusDate',
    title: 'Status Date',
    filter: 'date',
    format: '',
    width: '200px',
    dataType: 'date',
  },
  {
    field: 'poTotal',
    title: 'PO Total',
    filter: 'numeric',
    format: '',
    width: '150px',
    dataType: 'number',
    filterFormat: 'c',
  },
];

export default InvoiceColumns;
